// src/cookies/index.ts
var internlCreateCookie = ({ name, value, expiration = 1, path = "/", domain }) => {
  let expires = "";
  if (expiration > 0) {
    const days = (/* @__PURE__ */ new Date()).getTime() + 60 * 60 * 24 * Number(expiration) * 1e3;
    const expiresIn = new Date(days);
    expires = `;expires=${expiresIn.toUTCString()}`;
  } else {
    expires = `;expires=${(/* @__PURE__ */ new Date(0)).toUTCString()}`;
  }
  let cookie = `${name}=${value};path=${path}` + expires;
  if (domain) {
    cookie += `;domain=${domain}`;
  }
  document.cookie = cookie;
};
var createCookie = (props) => {
  eraseCookie(props.name, props.domain);
  internlCreateCookie(props);
};
var readCookie = (name) => {
  if (typeof document !== "undefined") {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ")
        c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0)
        return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
};
var eraseCookie = (name, domain) => {
  internlCreateCookie({ name, value: "", expiration: 0, domain });
};

export {
  createCookie,
  readCookie,
  eraseCookie
};
//# sourceMappingURL=chunk-UFCTKZW2.mjs.map